var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5C11.2375 9.5 9 11.7375 9 14.5C9 17.2625 11.2375 19.5 14 19.5C16.7625 19.5 19 17.2625 19 14.5C19 11.7375 16.7625 9.5 14 9.5ZM25.175 13.25C24.6 8.0375 20.4625 3.9 15.25 3.325V0.75H12.75V3.325C7.5375 3.9 3.4 8.0375 2.825 13.25H0.25V15.75H2.825C3.4 20.9625 7.5375 25.1 12.75 25.675V28.25H15.25V25.675C20.4625 25.1 24.6 20.9625 25.175 15.75H27.75V13.25H25.175ZM14 23.25C9.1625 23.25 5.25 19.3375 5.25 14.5C5.25 9.6625 9.1625 5.75 14 5.75C18.8375 5.75 22.75 9.6625 22.75 14.5C22.75 19.3375 18.8375 23.25 14 23.25Z",
    fill: "#5FBB97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d2d91967b6822e846140ca6836d07538.svg";
export { ForwardRef as ReactComponent };